import { cn } from "@/lib/utils";

interface EventTitleWrapperProps {
  children: React.ReactNode;
  className?: string;
}

const EventTitleWrapper = ({ children, className }: EventTitleWrapperProps) => (
  <div className={cn("flex flex-wrap items-center gap-1.5 sm:gap-2", className)}>{children}</div>
);

interface ActionTextProps {
  children: React.ReactNode;
  className?: string;
}

export const ActionText = ({ children, className }: ActionTextProps) => (
  <span className={cn("whitespace-nowrap text-sm text-gray-600", className)}>{children}</span>
);

export default EventTitleWrapper;
